import { AvatarName as _AvatarName } from 'react-components';
import useUserAvatar from './useUserAvatar';
import { Props } from './types';

export default function AvatarName({ size = 'M', background = 'grey' }: Props) {
  const { initials } = useUserAvatar();

  return <_AvatarName initials={initials} size={size} background={background} />;
}
